import styled from "styled-components";
import { Input } from "../Form/styles";

export const Container = styled.div`
  width: 100%;
  max-width: 400px;
`;

export const NumberInput = styled(Input)`
  max-width: 150px;
  align-self: center;
  text-align: center;
`;
